import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { finalize, tap, delay } from "rxjs/operators";
import { LoaderService } from '../services/loader.service'

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    private totalRequests = 0;

    constructor(public loaderService: LoaderService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.totalRequests++;
        this.loaderService.show();

        return next.handle(req).pipe(
            tap(
                event => {
                    if (event instanceof HttpResponse) {
                        // Successful response
                    }
                },
                error => {
                    // Error occurred
                    this.decreaseRequests();
                }
            ),
            finalize(() => {
                // Add a small delay before hiding the loader to ensure UI rendering completes
                setTimeout(() => {
                    this.decreaseRequests();
                }, 100);
            })
        );
    }

    private decreaseRequests() {
        this.totalRequests--;
        if (this.totalRequests <= 0) {
            this.totalRequests = 0;
            this.loaderService.hide();
        }
    }
}